<div class="dialog">
  <div class="dialog__title">
    <div class="dialog__header">
      <h5>Edit article</h5>
    </div>
    <mat-icon class="dialog__close" role="button" aria-label="Close" mat-dialog-close>close</mat-icon>
  </div>

  <div class="dialog__content" mat-dialog-content>
    <section class="dialog__section">
      <div class="section-form-container">
        <form [formGroup]="articleForm" *ngIf="articleForm">
          <formly-form [fields]="formField" [form]="articleForm" [model]="model"></formly-form>
        </form>
      </div>
    </section>
  </div>

  <div class="dialog__actions" mat-dialog-actions align="end">
    <mds-button type="secondary" (click)="onCancel()" aria-label="Cancel">Cancel</mds-button>
    <mds-button
      [disabled]="articleForm.invalid"
      class="actions__save ml-20"
      type="primary"
      aria-label="Save"
      (click)="onSave()"
    >
      Save
    </mds-button>
  </div>
</div>
